import LazyImage, { LazyImageProps } from "@insite/mobius/LazyImage";
import Typography, { TypographyProps } from "@insite/mobius/Typography";
import React, { useEffect, useRef, useState } from "react";
import { connect } from "react-redux";

import { parserOptions } from "@insite/client-framework/Common/BasicSelectors";
import mergeToNew from "@insite/client-framework/Common/mergeToNew";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { useGetLink } from "@insite/client-framework/Store/Links/LinksSelectors";
import translate from "@insite/client-framework/Translate";
import { HasFields } from "@insite/client-framework/Types/ContentItemModel";
import { LinkFieldValue } from "@insite/client-framework/Types/FieldDefinition";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import Clickable from "@insite/mobius/Clickable";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import GridContainer, { GridContainerProps } from "@insite/mobius/GridContainer";
import GridItem, { GridItemProps } from "@insite/mobius/GridItem";
import Icon from "@insite/mobius/Icon";
import X from "@insite/mobius/Icons/X";
import { breakpointMediaQueries } from "@insite/mobius/utilities";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { COLORS } from "@tKgpco/theme/design";
import parse from "html-react-parser";
import { css } from "styled-components";

const mapStateToProps = (state: ApplicationState) => ({
    subLinkId: state.data.pages.location.search,
});

interface ImageTextCardModel {
    fields: {
        id: string;
        title: string;
        image: string;
        description?: string;
        isLink: boolean;
        linkURL?: LinkFieldValue;
    };
}

const enum fields {
    imageTextCard = "imageTextCard",
}

interface OwnProps extends WidgetProps {
    fields: {
        [fields.imageTextCard]: ImageTextCardModel[];
    };
    extendedStyles?: OfferingStyles;
}
interface OwnSubProps {
    cardData: any;
    extendedStyles?: OfferingStyles;
}

type Props = OwnProps & ReturnType<typeof mapStateToProps>;

export interface OfferingStyles {
    image?: LazyImageProps;
    cardTitle: TypographyProps;
    cardHeaderTitle?: TypographyProps;
    cardCloseIcon?: InjectableCss;
    gridWrapper?: GridContainerProps;
    containerDetailsCardsWrapper?: GridContainerProps;
    descriptionDetailedWrapper?: GridContainerProps;
    gridItem?: GridItemProps;
    descriptionWrapper?: InjectableCss;
    cardWrapper?: InjectableCss;
    descriptionWrapperOne?: GridItemProps;
    descriptionWrapperTwo?: GridItemProps;
    cardClickWrapper?: InjectableCss;
}

export const offeringStyles: OfferingStyles = {
    gridWrapper: {
        // gap: 20,
        css: css`
            flex-wrap: wrap;
            .hideDeatilsCard {
                min-height: 0px;
                height: 0px;
                overflow: hidden;
                opacity: 0;
                transition: all 0.5s;
            }
            .showDeatilsCard {
                display: flex;
                flex-direction: column;
                width: 100%;
                background-color: ${COLORS.primary.light};
                margin: 10px 20px;
                min-height: 300px;
                height: auto;
                overflow: auto;
                opacity: 1;
                transition: height 0.5s, overflow 0.5s, opacity 0.5s;
                ${({ theme }: { theme: BaseTheme }) =>
                    breakpointMediaQueries(theme, [
                        css`
                            padding: 20px 20px;
                        `,
                        css`
                            padding: 20px 20px;
                        `,
                        css`
                            padding: 35px 35px;
                        `,
                        css`
                            padding: 35px 35px;
                        `,
                        css`
                            padding: 35px 35px;
                        `,
                    ])}
            }
            .card_header {
                display: flex;
                justify-content: flex-end;
            }
        `,
    },
    cardClickWrapper: {
        css: css`
            width: 100%;
            &:focus {
                outline-color: transparent;
            }
        `,
    },
    containerDetailsCardsWrapper: {
        css: css`
            padding: 15px 20px;
        `,
    },
    cardTitle: {
        variant: "h2",
        css: css`
            margin: 0;
            width: 100%;
        `,
    },
    cardHeaderTitle: {
        variant: "h1",
        color: COLORS.white,
    },
    cardCloseIcon: {
        css: css`
            color: ${COLORS.white};
        `,
    },
    gridItem: {
        width: [12, 12, 4, 4, 4],
        css: css`
            align-items: center;
            flex-direction: column;
            button {
                width: 100%;
            }
        `,
    },
    descriptionWrapper: {
        css: css`
            padding: 25px 20px;
            display: flex;
            flex-direction: column;
            flex-grow: 1;
        `,
    },
    cardWrapper: {
        css: css`
            background: ${COLORS.white};
            display: flex;
            flex-direction: column;
            flex-grow: 1;
            border-radius: 10px;
            width: 100%;
            overflow: hidden;
            &:hover {
                img {
                    transition: all 0.5s linear;
                    transform: scale(1.03);
                }
            }
        `,
    },
    image: {
        css: css`
            height: auto;
            img {
                width: 100%;
                height: auto;
            }
        `,
    },
    descriptionDetailedWrapper: {
        gap: 20,
    },
    descriptionWrapperOne: {
        width: [12, 12, 4, 4, 4],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 10px;
                    `,
                    css`
                        padding: 10px;
                    `,
                    css`
                        padding: 40px 40px 40px 10px;
                    `,
                    css`
                        padding: 40px 40px 40px 10px;
                    `,
                    css`
                        padding: 40px 40px 40px 10px;
                    `,
                ])}
        `,
    },
    descriptionWrapperTwo: {
        width: [12, 12, 8, 8, 8],
        css: css`
            ${({ theme }: { theme: BaseTheme }) =>
                breakpointMediaQueries(theme, [
                    css`
                        padding: 10px;
                    `,
                    css`
                        padding: 10px;
                    `,
                    css`
                        padding: 40px 40px 40px 10px;
                    `,
                    css`
                        padding: 40px 40px 40px 10px;
                    `,
                    css`
                        padding: 40px 40px 40px 10px;
                    `,
                ])}
        `,
    },
};

const ImageTextCard: React.FC<Props> = ({ fields, extendedStyles, subLinkId }) => {
    const [styles] = useState(() => mergeToNew(offeringStyles, extendedStyles));
    const [pageUrlId, setPageUrlId] = React.useState("");
    const sectionRef = React.useRef<any>();
    const [divData, setDivData] = useState({
        cardDetailTitle: "",
        cardDetailDescription: "",
    });
    const [mainDivIndex, setMainDivIndex] = useState<null | number>(null);
    const inputEl = useRef<any>();
    const [refDiv, setRefDiv] = useState<any>([]);
    const [cardMainArr, setcardMainArr] = useState<any>([]);

    const dataArr = fields.imageTextCard;
    const newArr: any = [];

    const scrollToSection = (id: string) => {
        const clickedSection = document.querySelector(`[id="${id}"]`);
        if (clickedSection) {
            const { top } = clickedSection.getBoundingClientRect();
            window.scrollTo({
                top: top + window.pageYOffset,
                left: 0,
                behavior: "smooth",
            });
        }
    };

    useEffect(() => {
        const cardMainArr = [];
        let tempCardArr = [];
        for (let i = 0; i < dataArr.length; i++) {
            tempCardArr.push(dataArr[i]);
            if ((i + 1) % 3 === 0 || i === dataArr.length - 1) {
                cardMainArr.push({ cards: tempCardArr });
                tempCardArr = [];
                newArr.push(false);
            }
        }
        setRefDiv(newArr);
        setcardMainArr(cardMainArr);
    }, [dataArr]);

    useEffect(() => {
        inputEl.current?.scrollIntoView({ block: "center", behavior: "smooth" });
    }, [refDiv]);

    useEffect(() => {
        const path = subLinkId.split("=");
        const id = path[1]?.replace(/(\r\n|\n|\r)/gm, "");
        setPageUrlId(id);
        if (subLinkId && pageUrlId) {
            setTimeout(() => {
                scrollToSection(id);
            }, 500);
        }
    }, [subLinkId, pageUrlId]);

    const divisibiltyHandler = (index: any) => {
        if (index !== null) {
            const tempDivArr: any = [];
            // eslint-disable-next-line array-callback-return
            refDiv.map(() => {
                tempDivArr.push(false);
            });
            tempDivArr[index] = true;
            setRefDiv(tempDivArr);
        }
    };
    return (
        <GridContainer {...styles.gridWrapper}>
            {cardMainArr &&
                cardMainArr.map((mainCon: any, conInndex: any) => {
                    return (
                        <React.Fragment key={`mainContainer_${conInndex}`}>
                            <GridContainer {...styles.containerDetailsCardsWrapper}>
                                {mainCon.cards.map((card: any, cardIndex: any) => {
                                    return (
                                        <GridItem
                                            {...styles.gridItem}
                                            key={card.fields.title.split(" ").join("_")}
                                            id={card.fields.id?.replace(/ /g, "")}
                                            onClick={() => {
                                                divisibiltyHandler(card.fields.isLink ? null : conInndex);
                                                setMainDivIndex(card.fields.isLink ? null : conInndex);
                                            }}
                                        >
                                            {card.fields.isLink ? (
                                                <CustomLinkComponent cardData={card.fields} />
                                            ) : (
                                                <Clickable
                                                    onClick={() => {
                                                        setDivData({
                                                            cardDetailTitle: card.fields.title,
                                                            cardDetailDescription: card.fields?.description,
                                                        });
                                                    }}
                                                    {...styles.cardClickWrapper}
                                                >
                                                    <StyledWrapper {...styles.cardWrapper}>
                                                        <LazyImage {...styles.image} src={card.fields.image} />
                                                        <StyledWrapper {...styles.descriptionWrapper}>
                                                            <Typography {...styles.cardTitle}>
                                                                {translate(card?.fields?.title)}
                                                            </Typography>
                                                        </StyledWrapper>
                                                    </StyledWrapper>
                                                </Clickable>
                                            )}
                                        </GridItem>
                                    );
                                })}
                            </GridContainer>
                            <StyledWrapper
                                className={mainDivIndex === conInndex ? "showDeatilsCard" : "hideDeatilsCard"}
                                ref={refDiv[conInndex] ? inputEl : null}
                                tabIndex={conInndex + 1}
                            >
                                <StyledWrapper className="card_header">
                                    <Typography as="div">
                                        <Clickable
                                            onClick={() => {
                                                setMainDivIndex(null);
                                            }}
                                        >
                                            <Icon src={X} {...styles.cardCloseIcon} />
                                        </Clickable>
                                    </Typography>
                                </StyledWrapper>
                                <GridContainer {...styles.descriptionDetailedWrapper}>
                                    <GridItem {...styles.descriptionWrapperOne}>
                                        <Typography {...styles.cardHeaderTitle}>
                                            {translate(divData?.cardDetailTitle)}
                                        </Typography>
                                    </GridItem>
                                    <GridItem {...styles.descriptionWrapperTwo}>
                                        {parse(divData?.cardDetailDescription, parserOptions)}
                                    </GridItem>
                                </GridContainer>
                            </StyledWrapper>
                        </React.Fragment>
                    );
                })}
        </GridContainer>
    );
};
const CustomLinkComponent = ({ cardData, extendedStyles }: OwnSubProps) => {
    const { title, url } = useGetLink(cardData?.linkURL);
    const [styles] = useState(() => mergeToNew(offeringStyles, extendedStyles));

    if (!url) {
        return null;
    }

    return (
        <Clickable href={url} {...styles.cardClickWrapper}>
            <StyledWrapper {...styles.cardWrapper}>
                <LazyImage {...styles.image} src={cardData?.image} />
                <StyledWrapper {...styles.descriptionWrapper}>
                    <Typography {...styles.cardTitle}>{translate(cardData?.title)}</Typography>
                </StyledWrapper>
            </StyledWrapper>
        </Clickable>
    );
};

const contentTab = {
    displayName: "Content",
    sortOrder: 0,
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ImageTextCard),
    definition: {
        group: "Common",
        fieldDefinitions: [
            {
                name: fields.imageTextCard,
                editorTemplate: "ListField",
                tab: contentTab,
                // eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
                getDisplay: (item: HasFields) => {
                    return item.fields.title;
                },
                defaultValue: [],
                fieldType: "Translatable",
                fieldDefinitions: [
                    {
                        name: "image",
                        editorTemplate: "ImagePickerField",
                        defaultValue: "",
                    },
                    {
                        name: "id",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "title",
                        editorTemplate: "TextField",
                        defaultValue: "",
                    },
                    {
                        name: "isLink",
                        editorTemplate: "CheckboxField",
                        defaultValue: false,
                    },
                    {
                        name: "linkURL",
                        displayName: "Card Link",
                        editorTemplate: "LinkField",
                        defaultValue: { type: "Page", value: "" },
                        isVisible: item => item.fields.isLink,
                        isRequired: true,
                    },
                    {
                        name: "description",
                        editorTemplate: "RichTextField",
                        defaultValue: "",
                        isVisible: item => !item.fields.isLink,
                    },
                ],
            },
        ],
    },
};

export default widgetModule;
